import React from "react";

// -----------------import styling------------------------
import { ParentDiv, PointsDiv } from "./WhyChoosePTC.styled";

const WhyChoosePTC = () => {
  return (
    <ParentDiv>
      <h1>why choose ptc</h1>
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Commodi magni
        ipsum reiciendis excepturi, aspernatur voluptatem maiores:
      </p>
      <PointsDiv>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi! Animi saepe nam expedita, eum autem aliquid ut in vel
          officiis! Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Dolorum maiores quas voluptates debitis quo animi est, dolores.
        </p>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi! Animi saepe nam expedita.
        </p>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi! Animi saepe nam expedita, eum autem aliquid ut in vel
          officiis! Lorem ipsum dolor sit.
        </p>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi! Animi saepe nam expedita, eum autem aliquid ut in vel
          officiis! Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Dolorum maiores quas voluptates debitis quo animi est.
        </p>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi.
        </p>
        <h3>Lorem ipsum:</h3>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet nihil
          obcaecati tempora error consequuntur consequatur dolor quasi excepturi
          eligendi! Animi saepe nam expedita, eum autem aliquid ut in vel
          officiis! Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </p>
      </PointsDiv>
    </ParentDiv>
  );
};

export default WhyChoosePTC;
